import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { useUserData } from "./useUserProfile";

import { getActiveSyncLogs } from "../api/reports/reports";
import { createErrorMessage } from "../utils/createErrorMessage";

export const useActiveSyncLogs = () => {
  const { organizationId, tenantId } = useUserData();
  const params = useParams();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["getActiveSyncLogs", tenantId, organizationId, params.reportId],
    queryFn: async () => {
      try {
        const logList = await getActiveSyncLogs(
          organizationId,
          tenantId,
          params.reportId!
        );

        return logList.data.data;
      } catch (error) {
        toast.error(createErrorMessage(error));
      }
    },
    enabled: !!tenantId && !!params.reportId,
  });

  const getCurrent = useCallback(() => {
    if (Array.isArray(data) && data.length) {
      return data.find((log) => log.isActive && log.isCurrent);
    }

    return null;
  }, [data]);

  return {
    data,
    isLoading,
    error,
    refetch,
    getCurrent
  };
};
